export const DANG_NHAP_ACTION = 'DANG_NHAP_ACTION';
export const SET_THONG_TIN_NGUOI_DUNG = 'SET_THONG_TIN_NGUOI_DUNG';
export const DANG_KY_ACTION = 'DANG_KY_ACTION';
export const SET_THONG_TIN_NGUOI_DUNG_THEO_TAI_KHOAN = 'SET_THONG_TIN_NGUOI_DUNG_THEO_TAI_KHOAN';
export const SET_DANH_SACH_NGUOI_DUNG = 'SET_DANH_SACH_NGUOI_DUNG'